export default ($el: Element) => {
	if ($el instanceof HTMLElement) {
        const contentDiv = $el.querySelector('.line-clamp');
        const readMore = $el.querySelector('.read-more') as HTMLElement;
        const readLess = $el.querySelector('.read-less') as HTMLElement;

		$el.querySelector('button')?.addEventListener('click', () => {
            $el.classList.toggle('line-clamped');
            contentDiv?.classList.toggle('line-clamp');
            
            const isClamped = $el.classList.contains('line-clamped');
            readMore.classList.toggle('hidden', !isClamped);
            readLess.classList.toggle('hidden', isClamped);
        });
	}
}
